import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-20">
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Privacy Policy
            </h1>
            <p className="text-gray-400">Last updated: December 26, 2024</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            <p className="text-lg leading-relaxed">
              Orboroi ("we", "our", or "us") is committed to protecting your privacy and ensuring the security of any information you share with us.
            </p>

            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
              <p className="mb-3">We may collect the following types of information:</p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Contact information (name, email, company, job title)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Communication data (messages, inquiries, meeting details)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Website usage data (cookies, analytics, IP address, browser type)</span>
                </li>
              </ul>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Information</h2>
              <p className="mb-3">We use the collected information to:</p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Respond to inquiries and communicate with you</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Provide and improve our services</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Operate, maintain, and optimize our website</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Support business development and client relationships</span>
                </li>
              </ul>
              <p className="mt-4 font-semibold text-white">We do not sell, rent, or trade your personal data.</p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Data Handling & AI Operations</h2>
              <p className="mb-3">
                As part of our services, we may process data related to AI model development, evaluation, or data operations.
              </p>
              <p>
                All such data is handled with strict confidentiality and used only for agreed purposes under client engagements.
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect data from unauthorized access, loss, or misuse.
              </p>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Third-Party Services</h2>
              <p>
                We may use trusted third-party tools (e.g., analytics, CRM, hosting providers) that process data on our behalf under appropriate safeguards.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Data Retention</h2>
              <p>
                We retain information only as long as necessary for business or legal purposes.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Your Rights</h2>
              <p className="mb-3">Depending on your location, you may have rights to:</p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Access your data</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Request correction or deletion</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#379F7F] mr-3 mt-1">•</span>
                  <span>Object to or restrict processing</span>
                </li>
              </ul>
              <p className="mt-4">To exercise these rights, contact us at the email below.</p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. International Users</h2>
              <p>
                If you are accessing this website from outside our operating region, your data may be processed in other jurisdictions with appropriate safeguards.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically. Continued use of the website constitutes acceptance of updates.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Contact</h2>
              <p>
                For any questions or concerns regarding this Privacy Policy, please contact us at:
              </p>
              <p className="mt-2">
                <a href="mailto:contact@orboroi.com" className="text-[#379F7F] hover:underline">
                  contact@orboroi.com
                </a>
              </p>
            </section>
          </div>

          {/* Back to home link */}
          <div className="mt-12 pt-8 border-t border-gray-800">
            <Link to="/" className="text-[#379F7F] hover:underline inline-flex items-center">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;